<template>
  <!-- 刮卡任务 -->
  <div class="game-scratch-go">
    <div class="game-content">
      <div v-for="(item, index) in taskList" :key="index" class="game-scratch-list">
        {{ index + 1 }}.{{ item.name }}
        <img v-if="item.num === 0" src="@this/assets/image_59.png" @click="clickTask(item)" />
        <img v-else @click="clickTask(item)" src="@this/assets/image_18.png" />
      </div>
      <div v-if="!showAllTask" @click="changeShowAllTask" class="game-scratch-more">查看更多任务>></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    taskList: {
      type: Array,
      default() {
        return [];
      },
    },
    showAllTask: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickTask(task) {
      this.$emit('clickTask', task);
    },
    changeShowAllTask() {
      this.$emit('changeShowAllTask');
    },
  },
};
</script>

<style lang="scss" scoped>
  .game-scratch-go {
     background: url(~@this/assets/image-05.png) no-repeat;
     background-size: 100% 100%;
    width: 592px;
     height: 144px;
     padding: 20px 40px 20px;
     margin-top: 10px;
     .game-content{
       height: 144px;
       overflow-y: scroll;
     }
    .game-scratch-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid#495088;
      color:#436c6a;
      font-weight: 800;
      &:nth-last-child(1){
       border-bottom: 1px solid transparent;
      }
      > img {
        width: 123px;
        height: 53px;
      }
    }
    .game-scratch-more {
      color: #d71b1f;
      text-align: center;
      font-weight: 800;
      margin-top: 14px;
      font-size: 30px;
    }
  }
  .game-scratch-more {
    color: #ffcf6f;
    text-align: center;
    font-weight: 800;
    margin-top: 14px;
    font-size: 30px;
  }
</style>
